import { ChangeDetectionStrategy, Component, computed, inject, model, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { finalize, forkJoin } from 'rxjs';
import { LoaderService } from '../../core';
import { UserService } from '../../services';
import { BaseComponent } from '../base';


/**
 * Component for language selection.
 */
@Component({
	selector: 'tsp-language-selection',
	imports: [
		FormsModule
	],
	templateUrl: './language-selection.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class LanguageSelectionComponent extends BaseComponent implements OnInit {

	private readonly userSrv = inject(UserService);
	private readonly loaderSrv = inject(LoaderService);

	lang = model<string>();
	langList = signal<string[]>([]);

	isVisible = computed(() => this.langList()?.length > 1);

	private _prevLang?: string;


	ngOnInit(): void {
		forkJoin([this.userSrv.getLanguages(), this.userSrv.getUserLanguage()]).subscribe(([langs, lang]) => {
			this.langList.set([...langs]);
			this.lang.set(lang ?? this.langSrv.DEFAULT_LANG);
			this._prevLang = this.lang();
		});
	}

	/**
	 * Change user language.
	 */
	changeLanguage(): void {
		this.loaderSrv.show();
		this.userSrv.changeLanguage(this.lang()!).pipe(
			finalize(() => this.loaderSrv.hide())
		).subscribe({
			next: () => {
				this._prevLang = this.lang();
				window.location.reload();
			},
			error: () => this.lang.set(this._prevLang)
		});
	}

}
